import type { FC } from 'react';

import { SkeletonBlock } from '../ui/SkeletonBlock';

import { useOpenCommunitySearch } from '../../_hooks/useOpenCommunitySearch';
import { CommunityIdentity } from '../CommunityIdentity';
import { TopBarNavLinks } from './_components/TopBarNavLinks';
import { TopBarSearch } from './_components/TopBarSearch';
import { TopBarUser } from './_components/TopBarUser';

interface TopBarProps {
  notificationUnreadCount?: number | null;
  isFetchingSubscription?: boolean;
}

export const TopBar: FC<TopBarProps> = ({ notificationUnreadCount, isFetchingSubscription = false }) => {
  const openSearch = useOpenCommunitySearch();

  return (
    <header className="flex shrink-0 items-center gap-2 bg-community-bg px-3 pt-3 text-community-text-on-bg">
      <div className="min-w-48 flex-1">
        <CommunityIdentity />
      </div>
      <div className="w-96 min-w-0">
        <TopBarSearch onClick={openSearch} />
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <div className="flex items-center">
          <TopBarNavLinks notificationUnreadCount={notificationUnreadCount} />
        </div>
        {isFetchingSubscription ? <SkeletonBlock className="size-10 animate-pulse !rounded-full" /> : <TopBarUser />}
      </div>
    </header>
  );
};
